import { Injectable, Type } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import * as Models from '@shared/models';
import { GenericConfirmModalComponent } from '../components/generic-modal/genericModal.component';

export interface SDModalOptions {
  resolve?: Record<string, unknown>;
  content?: Type<unknown>;
  modalOptions?: MatDialogConfig;
}

export interface IModalService {
  openConfirmModal(modalParams: Models.IConfirmModalParams): MatDialogRef<unknown>;
  openModal(modalOptions: SDModalOptions): MatDialogRef<unknown>;
}

@Injectable()
export class ModalService implements IModalService {
  constructor(private modalService: MatDialog) {}

  openConfirmModal(modalParams: Models.IConfirmModalParams): MatDialogRef<unknown> {
    const cfg: SDModalOptions = {
      content: GenericConfirmModalComponent,
      modalOptions: {
        panelClass: modalParams.modalSize || 'lgModal',
        disableClose: true,
        data: modalParams,
      },
    };
    return this.openModal(cfg);
  }

  openModal(config: SDModalOptions): MatDialogRef<unknown> {
    const modalOptions = Object.assign(
      {},
      {
        panelClass: 'lgModal',
        disableClose: true,
      },
      config.modalOptions
    );

    const modal = this.modalService.open(config.content ?? GenericConfirmModalComponent, modalOptions);

    if (config.resolve && modal.componentInstance) {
      const instance = modal.componentInstance as Record<string, unknown>;
      const componentRef = (
        modal as MatDialogRef<unknown> & {
          componentRef?: { setInput?: (name: string, value: unknown) => void };
        }
      ).componentRef;

      for (const key in config.resolve) {
        if (!Object.prototype.hasOwnProperty.call(config.resolve, key)) {
          continue;
        }

        const value = config.resolve[key];
        const targetProperty = instance[key];
        const isSignalInput = typeof targetProperty === 'function';

        if (isSignalInput && componentRef?.setInput) {
          componentRef.setInput(key, value);
          continue;
        }

        instance[key] = value;
      }
    }

    return modal;
  }
}
